import {backendUrl} from "../globalConfig";


export const addNewTeam = async (fullName: string, email: string, telegram: string, itAges: number, teamName: string, streamName: string, projectAbout: string, ref: string) => {
    fetch(backendUrl+'/teams/create_new_team', {
        method: 'POST',
        // credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            nick_name: ref,
            full_name: fullName,
            email: email,
            telegram: telegram,
            it_ages: itAges,
            team_name: teamName,
            stream: streamName,
            project_about: projectAbout,
        })
    })
}
